/**
 * Google analytics tracking.
 */
/* eslint-disable */

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', wp_data.gaId);



// WEBPACK FOOTER //
// ./src/js/google-analytics.js